document.addEventListener('DOMContentLoaded', function() {
  const stockFilter = document.getElementById('filter-filter.v.availability-1');
  const otherFilters = document.querySelectorAll('.filter__content input[type="checkbox"]:not(#filter-filter.v.availability-1)');

  otherFilters.forEach(filter => {
    filter.addEventListener('change', () => {
      if (!stockFilter.checked) {
        stockFilter.checked = true;
        triggerFilterUpdate();
      }
    });
  });

  function triggerFilterUpdate() {
    stockFilter.dispatchEvent(new Event('change'));
  }

  function isProductOutOfStock() {
    return document.querySelector('button[data-add-to-cart-text="Add to cart"][disabled]') !== null;
  }

  function updateIconVisibility() {
    var priceElement = document.querySelector('.price__current');
    var freeShippingIcon = document.querySelector('.free-shipping-icon');
    var topQualityIcon = document.querySelector('.top-quality-icon');
    var expertSupportIcon = document.querySelector('.expert-support-icon');
    var trustedBusinessIcon = document.querySelector('.trusted-business-icon');

    if (isProductOutOfStock()) {
      if (freeShippingIcon) freeShippingIcon.style.display = 'none';
      if (topQualityIcon) topQualityIcon.style.display = 'none';
      if (expertSupportIcon) expertSupportIcon.style.display = 'none';
      if (trustedBusinessIcon) trustedBusinessIcon.style.display = 'none';
      return;
    }

    if (priceElement) {
      var priceText = priceElement.textContent.trim();
      var productPrice = parseFloat(priceText.replace('₹', '').replace(',', ''));

      if (freeShippingIcon) {
        freeShippingIcon.style.display = productPrice >= 2000 ? 'inline' : 'none';
      }
    }

    if (topQualityIcon) {
      topQualityIcon.style.display = 'inline';
    }

    if (expertSupportIcon) {
      expertSupportIcon.style.display = isProductOutOfStock() ? 'none' : 'inline';
    }

    if (trustedBusinessIcon) {
      trustedBusinessIcon.style.display = isProductOutOfStock() ? 'none' : 'inline';
    }
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        updateIconVisibility();
      }
    });
  });

  var targetNode = document.querySelector('.product-info');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, attributes: true, subtree: true });
  }

  updateIconVisibility();
});
